import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * Hotel icon for representing accommodations and lodging
 */
export const HotelIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M3 14h18v7H3z"></path>
      <rect x="4" y="4" width="16" height="10" rx="2" ry="2"></rect>
      <path d="M9 8h1"></path>
      <path d="M14 8h1"></path>
      <path d="M9 12h1"></path>
      <path d="M14 12h1"></path>
      <path d="M10 18v3"></path>
      <path d="M14 18v3"></path>
    </Icon>
  );
};

export default HotelIcon;
